module.exports = __webpack_public_path__ + "img/lineSs.225317bf.png";